import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteRecord} from "../services/ActivityLogsService.ts";
import {useActivityLogsSelection} from "../hooks/useActivityLogsSelection.ts";

export const DeleteRecordButton = () => {
    const {selectedRecords, clearSelection} = useActivityLogsSelection();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async () => {
            await Promise.all(selectedRecords.map(record => deleteRecord(record.id)));
            clearSelection();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['activity-logs']});
        }
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={mutation.mutate}
        />
    );
};
